import React, { useState, useEffect } from "react";
import { firebaseDB } from "firebase/client";
import {
  defaultSiteConfig,
  SITE_CONFIG_COLLECTION,
  SITE_CONFIG_DOCUMENT,
} from "config/site";

export const SiteConfigContext = React.createContext(defaultSiteConfig);

// Mergea el documento de Firestore sobre los defaults respetando la estructura
// de `defaultSiteConfig`: sólo se toman las secciones conocidas y, dentro de
// cada una, sólo las claves definidas. Así un documento incompleto o con campos
// de más nunca deja la home en un estado inesperado.
function mergeSiteConfig(overrides) {
  if (!overrides) return defaultSiteConfig;

  return Object.keys(defaultSiteConfig).reduce((config, section) => {
    config[section] = { ...defaultSiteConfig[section] };

    const sectionOverrides = overrides[section];

    if (sectionOverrides) {
      Object.keys(defaultSiteConfig[section]).forEach((key) => {
        if (sectionOverrides[key] !== undefined) {
          config[section][key] = sectionOverrides[key];
        }
      });
    }

    return config;
  }, {});
}

export function SiteConfigProvider({ children }) {
  const [siteConfig, setSiteConfig] = useState(defaultSiteConfig);

  useEffect(() => {
    firebaseDB
      .collection(SITE_CONFIG_COLLECTION)
      .doc(SITE_CONFIG_DOCUMENT)
      .get()
      .then((doc) => {
        if (doc.exists) {
          setSiteConfig(mergeSiteConfig(doc.data()));
        }
      })
      .catch((error) => {
        // Si el documento no existe o las reglas bloquean la lectura, la home
        // sigue funcionando con los valores compilados en `config/site.js`.
        console.log(
          `No se pudo leer ${SITE_CONFIG_COLLECTION}/${SITE_CONFIG_DOCUMENT}, se usan los valores por defecto.`,
          error.message
        );
      });
  }, []);

  return (
    <SiteConfigContext.Provider value={siteConfig}>
      {children}
    </SiteConfigContext.Provider>
  );
}
